import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaTurma = (): TabelaColuna => ({
  Chave: 'nomeCurso',
  Texto: 'Turma',
  StyleColuna: { width: 110, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => <>{linha.nomeTurma}</>
})
